const rental_order_termRouter = [
    {
        path: "list-rental_order_term",
        name: "list",
        component: () => import("@/views/admin/rental_order_term"),
        default: true,
        meta: {
            model: "rental_order_term",
        },
    },
  ];
  export default rental_order_termRouter;